// @flow
import * as React from 'react'

// Types
export type Props = {
  message: React.Element<any> | ?string,
  children: (any) => any,
}

/**
 * Small utility component that converts given `FormattedMessage` react element to
 * a `FormattedMessage` with children render function. Also it protects
 * the rendering if given message actually not a react element.
 * @param  {?string|Element<FormattedMessage>}  message  Message element or anything else
 * @return {Element}
 */
const FormattedWithChildren = ({ message, children }: Props) => {
  if (!React.isValidElement(message)) {
    return children(message)
  }
  return React.cloneElement((message: any), { alwaysRerender: true }, children)
}

export default FormattedWithChildren
